export const PERCENTAGE_MAX = 100;
export const typeOptions = [
  { label: 'Number', value: 'number' },
  { label: 'Percentage', value: 'percentage' },
];
export const defaultAllocation = {
  suppliers: [],
  requiredSample: { label: 'number', value: 0 },
  CPI: { label: 'number', value: 0 },
};

export const getServerError = (response, fallback) =>
  typeof response?.error === 'string' ? response.error : fallback;
export const getAllocationRules = ({
  sampleType,
  cpiType,
  expectedCompletes,
  surveyCpi,
  completed = 0,
  otherAllocated = 0,
}) => {
  const samplePct = sampleType === 'percentage';
  const cpiPct = cpiType === 'percentage';
  const total = positiveOrUndefined(Number(expectedCompletes));

  return {
    samplePct,
    cpiPct,
    sampleRule: {
      min: samplePct ? 0 : Math.max(1, completed),
      max: samplePct
        ? PERCENTAGE_MAX
        : total !== undefined
          ? Math.max(total - otherAllocated, 0)
          : undefined,
      integer: !samplePct,
      minNote:
        !samplePct && completed > 0
          ? `(${completed} already completed)`
          : undefined,
    },
    cpiRule: {
      min: 0,
      max: cpiPct ? PERCENTAGE_MAX : positiveOrUndefined(Number(surveyCpi)),
      integer: false,
    },
  };
};

export const positiveOrUndefined = (n) =>
  Number.isFinite(n) && n > 0 ? n : undefined;

export const asString = (v) => (typeof v === 'string' ? v : undefined);

export const checkNumber = (label, raw, rule, percent) => {
  if (raw === '' || raw === undefined || raw === null)
    return `${label} is required`;
  const n = Number(raw);
  const unit = percent ? '%' : '';
  if (!Number.isFinite(n)) return `${label} must be a valid number`;
  if (rule.integer && !Number.isInteger(n))
    return `${label} must be a whole number`;
  if (n <= 0) return `${label} must be greater than 0`;
  if (n < rule.min)
    return `${label} must be at least ${rule.min}${unit} ${rule.minNote || ''}`.trim();
  if (rule.max !== undefined && n > rule.max)
    return `${label} cannot exceed ${rule.max}${unit}`;
  return undefined;
};

export const withValueError = (errors, key, message) => {
  if (!message) return errors;
  const existing = typeof errors?.[key] === 'object' ? errors[key] : {};
  return {
    ...errors,
    [key]: { ...existing, value: existing.value ?? message },
  };
};

export const redirectFields = [
  { label: 'Complete', color: 'border-l-green-600', dbFieldName: 'complete' },
  {
    label: 'Terminate',
    color: 'border-l-yellow-500',
    dbFieldName: 'terminate',
  },
  {
    label: 'Security Terminate',
    color: 'border-l-red-600',
    dbFieldName: 'securityTerminate',
  },
  {
    label: 'Quota Full',
    color: 'border-l-blue-600',
    dbFieldName: 'quotaFull',
  },
];
